<template>
  <student-bookings />
</template>

<script>
import StudentBookings from '@/components/student/StudentBookings'

export default {
  components: { StudentBookings }
}
</script>
